var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgButtonDelete(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 686.4 686.4",
    style: {
      enableBackground: "new 0 0 686.4 686.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "current",
    x1: 75.6,
    y1: 75.6,
    x2: 410.8,
    y2: 410.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M410.8,455.8c-11.5,0-23-4.4-31.8-13.2L43.8,107.4c-17.6-17.6-17.6-46.1,0-63.6c17.6-17.6,46.1-17.6,63.6,0 l335.1,335.1c17.6,17.6,17.6,46.1,0,63.6C433.8,451.4,422.3,455.8,410.8,455.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "current",
    x1: 410.8,
    y1: 75.6,
    x2: 75.6,
    y2: 410.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M75.6,455.8c-11.5,0-23-4.4-31.8-13.2c-17.6-17.6-17.6-46.1,0-63.6L378.9,43.8c17.6-17.6,46.1-17.6,63.6,0 c17.6,17.6,17.6,46.1,0,63.6L107.4,442.6C98.6,451.4,87.1,455.8,75.6,455.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonDelete);
export default __webpack_public_path__ + "static/media/button-delete.79c9351651c325ed0dd2340a03255d1a.svg";
export { ForwardRef as ReactComponent };